import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { colorCssVars } from "src/theme/color";
import { cssForMediaSize, MediaSize } from "src/theme/mediaQueries";
import {
  spacing,
  verticalStackCss,
  horizontalStackCss,
} from "src/theme/spacing";
import { textSizeCss, FontWeight } from "src/theme/text";

export const PreviewButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
  justify-content: center;
  align-items: center;
  border-radius: 6px;

  height: 215px;
  width: 100%;
  background: linear-gradient(
    109.37deg,
    rgba(0, 163, 127, 0.1) 36.99%,
    rgba(0, 163, 127, 0) 100%
  );
`;

export const InstructionSection = styled.div`
  border-radius: 8px;
  padding: ${spacing.l};
  border: 1px solid var(${colorCssVars.dividerSoft});

  h3 {
    ${textSizeCss.m};
  }
`;

export const FormatAndPreviewSection = styled(InstructionSection)`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.m};
  align-items: center;
  ${cssForMediaSize({
    min: MediaSize.LARGE,
    css: {
      gridTemplateColumns: "1fr 1fr",
    },
  })}
`;

export const StyledH4 = styled.h4`
  ${textSizeCss.xs};
  color: var(${colorCssVars.text.secondary});
  font-weight: ${FontWeight.REGULAR};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.l};

  ${cssForMediaSize({
    min: MediaSize.LARGE,
    css: {
      gridTemplateColumns: "4fr 2fr",
    },
  })}
`;

export const Divider = styled.div`
  border-bottom: 1px var(${colorCssVars.dividerSoft}) solid;
`;

export const inputNextToButtonCss = [
  cssForMediaSize({ max: MediaSize.MEDIUM_SMALL, css: verticalStackCss.s }),
  cssForMediaSize({
    min: MediaSize.MEDIUM,
    css: [horizontalStackCss.m, { verticalAlign: "center" }],
  }),
];

export const buttonContentCss = css`
  ${horizontalStackCss.xs};
  align-items: center;
  justify-content: center;
  ${cssForMediaSize({
    min: MediaSize.MEDIUM,
    css: {
      justifyContent: "flex-start",
    },
  })}
`;

export const StyledCode = styled.code`
  ${textSizeCss.xs};
  background: var(${colorCssVars.background.faded});
  border-radius: 3px;
  padding: ${spacing.xxs};
`;
